import React, { Component } from 'react'
import {
  Title,
  Subtitle,
  Input,
  Paragraph,
  TextArea,
  CreateBtn,
  DatePicker,
  TimePicker,
  UploadBtn,
  SmallBtn
} from '../../components/Regular/index'

import Select from '../../components/Regular/Select'

import { AttendessTable } from '../../components/Table/index'

import Search from '../../components/Search/Search'

export default class AddAttendess extends Component {
  render() {

    const {
      goBack,
      // attendess left
      title,
      meeting_attendess,
      deleteAll,
      // attendess right
      all_department,
      selected_department,
      onSelect,
      selected_array,
      onAdd,
      onDelete,
      selectAll

    } = this.props

    return (
      <div className='container' >
        <div className='title-container' >
          <div className='create-left'>
            <Title text={'สร้างการประชุม'} />
          </div>
          <div className='create-right' >
            <Search marginTop={22} />
          </div>
        </div>

        <div className='attendess-container' >
          {/*  ============= Attendess Left =============  */}
          <div className='attendess-left' >
            <Subtitle text='ข้อมูลการประชุม' marginTop={20} />
            <Paragraph text='ขื่อการประชุม' marginTop={16} />
            <Input placeholder='ขื่อการประชุม' marginTop={6} disabled={true} value={title} />
            <span style={{ width: '100%', marginTop: 20, textAlign: 'right' }} onClick={deleteAll} ><a>ลบทั้งหมด</a></span>
            <Subtitle text='ผู้เข้าร่วมประชุม' marginTop={20} miniText={meeting_attendess.length} />
            <AttendessTable selectedPerson={meeting_attendess} tableMode={0} handleRemoveUser={onDelete} />
          </div>

          {/* ============= Attendess Right ============== */}
          <div className='attendess-right' >
            <Subtitle text='เลือกผู้เข้าร่วมประชุม' marginTop={20} />

            <Select title='เลือกหน่วยงาน' onChange={onSelect} options={all_department} value={selected_department} />
            <span style={{ width: '100%', marginTop: 20, textAlign: 'right' }} onClick={selectAll} ><a>เลือกทั้งหมด</a></span>
            <AttendessTable
              selectedPerson={selected_array}
              marginTop={20}
              tableMode={1}

              handleAddUser={onAdd}
              handleRemoveUser={onDelete}
            />
          </div>
        </div>
        <div className='attendess-footer' >
          <BackBtn onClick={goBack} />
          <CreateBtn text='+ เพิ่มการประชุม' onClick={this.props.onCreateConference} />
        </div>
      </div>
    )
  }
}

const BackBtn = ({ onClick }) => <div className="back-container">
  <a className="button is-large" onClick={onClick}>
    <span className="icon is-medium">
      <i className="fa fa-angle-left" />
    </span>
    <span>กลับ</span>
  </a>
</div>




// WEBPACK FOOTER //
// ./src/pages/Main/AddAttendess.js